import type { ReactElement, SVGProps } from "react"
import type {
  GetMyOptionsDtoResVoice,
  GetMyOptionsDtoResVoiceLang,
} from "../api/generated"

export const UserPlan = {
  FREE: "FREE",
  PRO: "PRO",
}

export type UserPlan = (typeof UserPlan)[keyof typeof UserPlan]

export type UserPayload = {
  id: string
  email: string | null
  isEmailConfirmed: boolean
  isGuest: boolean
  plan: UserPlan
}

export const Modal = {
  ONBOARDING: "ONBOARDING",
  PROCESS_CREATION_LOADING: "PROCESS_CREATION_LOADING",
  LISTEN_UNTIL: "LISTEN_UNTIL",
  CREATE_CONTENT_WITH_WEB_URL: "CREATE_CONTENT_WITH_WEB_URL",
  CREATE_CONTENT_WITH_TEXT: "CREATE_CONTENT_WITH_TEXT",
  RENAME_CONTENT: "RENAME_CONTENT",
  ARCHIVED_CONTENT: "ARCHIVED_CONTENT",
  SLEEP_TIMER: "SLEEP_TIMER",
  CHANGELOG: "CHANGELOG",
}
export type Modal = (typeof Modal)[keyof typeof Modal]

export type CombinedData = {
  end_ts: number
  height: number
  isAligned: boolean
  page: number
  start_ts: number
  width: number
  word: string
  x: number
  y: number
}

export interface LanguageVoice {
  label: string
  id: GetMyOptionsDtoResVoiceLang
  flag: (props: SVGProps<SVGSVGElement>) => ReactElement
}
export interface SelectVoiceItemType {
  id: GetMyOptionsDtoResVoice
  name: string
  gradient: [string, string, string]
  description?: string
}
